import { useBilling } from "../../hooks/useBilling";
import { useToast } from "../../hooks/useToast";
import { useState } from "react";
import { toErrorMessage } from "../../utils/errorMessage";

export function SubscribeButton() {
  const { createCheckout } = useBilling();
  const { showError } = useToast();
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    setLoading(true);
    try {
      await createCheckout();
    } catch (error: unknown) {
      console.error("Failed to create checkout:", error);
      showError(
        toErrorMessage(error, "Failed to create checkout session. Please try again."),
      );
      setLoading(false);
    }
  };

  return (
    <div className="glass-panel">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
          <span className="ghost-chip">Upgrade</span>
          <h3 className="mt-3 text-xl font-semibold text-slate-900">
            Subscribe to AR Space Commerce
          </h3>
          <p className="mt-1 text-sm text-slate-500">
            Unlock unlimited AR model generation and priority access to new features.
          </p>
        </div>
        <button
          type="button"
          onClick={handleSubscribe}
          disabled={loading}
          className="w-full rounded-2xl bg-gradient-to-r from-indigo-500 to-sky-500 px-6 py-3 text-sm font-semibold text-white shadow-xl shadow-indigo-200 transition hover:opacity-90 md:w-auto"
        >
          {loading ? "Redirecting..." : "Subscribe now"}
        </button>
      </div>
    </div>
  );
}
